import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  ControlLabel,
  Col,
  Button,
  FormControl,
  Glyphicon,
  Row,
} from "react-bootstrap";
import { PageSize } from "./PageSize";
import { Pagination } from "./Pagination";
import { MaxPageInPagination } from "./config";
import { makeStyles } from "@material-ui/core/styles";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Operation, DataType } from "../../constant";
import LoadingComponent from "components/LoadingComponent";

const useStyles = makeStyles({
  fieldItem: {
    display: "flex",
    marginBottom: "20px",
    minHeight: "35px",
    flexDirection: "column",
    ["@media (min-width:576px)"]: {
      alignItems: "center",
      flexDirection: "row",
    },

    "& label": {
      fontWeight: "normal",
      paddingLeft: 0,
    },

    "& > *": {
      marginLeft: "5px",
      marginBottom: "5px",
    },
  },
  shortWidthOnDesktop: {
    width: "100%",
    ["@media (min-width:576px)"]: {
      width: "100px",
    },
  },
});

export function RemoteGrid({
  filterFields,
  columns,
  data,
  pagination,
  loading,
  onTableChange,
  onSearch,
  defaultSorted,
  placeHolder = "search",
  ...props
}) {
  const [searchCriteria, setSearchCriteria] = useState({
    searchBy: filterFields && filterFields.find((x) => x.isDefault).key,
    searchText: "",
    operation: Operation.EQUAL,
  });
  const [searchByFieldDataType, setSearchByFieldDataType] = useState(
    filterFields && filterFields.find((x) => x.isDefault).dataType
  );

  const paginationOptions = {
    totalSize: data.totalRows,
    page: pagination.currentPage,
    sizePerPage: pagination.pageSize,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
    pageListRenderer: ({ onPageChange }) => (
      <Col sm={6} style={{ textAlign: "right" }}>
        <Pagination
          totalRows={data.totalRows}
          currentPage={pagination.currentPage}
          pageSize={pagination.pageSize}
          onPageChange={onPageChange}
          maxPage={MaxPageInPagination}
        />
      </Col>
    ),
    sizePerPageRenderer: ({ options, onSizePerPageChange }) => (
      <PageSize
        options={options}
        totalRows={data.totalRows}
        onPageSizeChange={onSizePerPageChange}
      />
    ),
  };

  const classes = useStyles();

  return (
    <LoadingComponent isLoading={loading}>
      <Row>
        <div className={classes.filter}>
          <Col lg={filterFields ? 5 : 9} className={classes.fieldItem} sty>
            <b>{data.totalRows} items found</b>
          </Col>
          <Col lg={filterFields ? 7 : 3} className={classes.fieldItem}>
            {filterFields && (
              <Col componentClass={ControlLabel} sm={5}>
                Search By
              </Col>
            )}

            {filterFields && (
              <select
                className="form-control"
                onChange={(e) => {
                  setSearchCriteria(
                    Object.assign(searchCriteria, { searchBy: e.target.value })
                  );
                  const dataType = filterFields.find(
                    (x) => x.key === e.target.value
                  ).dataType;
                  setSearchByFieldDataType(dataType);
                }}
              >
                {filterFields &&
                  filterFields.map((option, index) => (
                    <option
                      key={index}
                      value={option.key}
                      selected={option.isDefault}
                    >
                      {option.value}
                    </option>
                  ))}
              </select>
            )}

            {searchByFieldDataType === DataType.String && (
              <select
                className={`form-control ${classes.shortWidthOnDesktop}`}
                onChange={(e) =>
                  setSearchCriteria(
                    Object.assign(searchCriteria, { operation: e.target.value })
                  )
                }
              >
                {Object.keys(Operation).map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            )}

            <FormControl
              type={
                searchByFieldDataType === DataType.Integer ? "number" : "text"
              }
              placeholder={placeHolder}
              onChange={(e) =>
                setSearchCriteria(
                  Object.assign(searchCriteria, { searchText: e.target.value })
                )
              }
            />

            <Button
              onClick={() => onSearch(searchCriteria)}
              bsStyle="secondary"
              className={classes.shortWidthOnDesktop}
            >
              <Glyphicon glyph="search" />
              Search
            </Button>
          </Col>
        </div>
      </Row>

      <BootstrapTable
        {...props}
        keyField="id"
        data={data.items}
        columns={columns}
        pagination={paginationFactory(paginationOptions)}
        noDataIndication="No matching records found"
        onTableChange={onTableChange}
        remote
        striped
        hover
        defaultSorted={defaultSorted}
      />
    </LoadingComponent>
  );
}
